import {
  Button,
  Dialog,
  H4,
  Icon,
  DialogContent,
  DialogCTA,
} from "@sellar-io/components";

type DiscoveryV2DistributionInformationDialogProps = {
  open: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
};
export const DiscoveryV2DistributionInformationDialog = ({
  open,
  onDismiss,
  onConfirm,
}: DiscoveryV2DistributionInformationDialogProps) => {
  return (
    <Dialog active={open} onDismiss={onDismiss}>
      <DialogContent className="m-0 flex flex-col gap-4 p-4">
        <img
          alt="sellar-distribution-logo"
          src="https://sellar.imgix.net/sellar-image-assets/app-assets/discovery-distribution-banner-v2.png"
          className="rounded-lg object-fill lg:h-63.5"
        />
        <div className="flex items-start gap-4">
          <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-purple-50">
            <Icon
              icon="SELLAR_DISTRIBUTION_TRUCK"
              size={1}
              viewBox="0 0 16 16"
              className="text-[#8C23C7]"
            />
          </div>
          <div className="text-zinc-600">
            <H4 className="text-zinc-800">Delivered by Sellar</H4>
            <p>What's this?</p>
            <p>A flexible local delivery option coordinated by Sellar</p>
            <br />
            <p>What you get</p>
            <ul className="list-inside list-disc pl-2">
              <li>Choose AM or PM delivery</li>
              <li>Combined with your other Sellar orders where possible</li>
              <li>Delivered to your preferred drop-off location</li>
              <li>No pallets or courier handovers</li>
              <li>Free of charge</li>
            </ul>
          </div>
        </div>
      </DialogContent>
      <DialogCTA>
        <Button onClick={onConfirm}>Got it</Button>
      </DialogCTA>
    </Dialog>
  );
};
